import React, { useEffect, useState } from "react";
import OurStory from "./term-main/OurStory";
import { getTerms } from "../../utils/apis/common/Common";
import { Context } from "../../utils/context";
import parse from "html-react-parser";

const Term = () => {
  const [getTermsData, setGetTermsData] = useState();

  const getProject = async () => {
    const res = await getTerms();
    if (res?.success) {
      setGetTermsData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getProject();
  }, []);

  return (
    <>
      <section className="Privacy_Policy">
        <div className="bg_img_div">
          <div className="white_bg_div">
            <div className="container">
              <p className="section_title">Terms and Conditions</p>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="main_content_div">
            <p className="sub-text my-4">
              {" "}
              {typeof getTermsData?.description === "string"
                ? parse(getTermsData?.description)
                : ""}
            </p>
          </div>
        </div>
      </section>

      {/* old code */}
      {/* <OurStory /> */}
    </>
  );
};

export default Term;
